<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		:max-width="fullscreen? null: maxWidth"
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</slot>
				</template>
				<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<z-form v-model="item" class="mt-3" ref="parameters"></z-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
//import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zForm from '@/views/forms/vehicle.parameters.park'

export default {
	name: 'DialogDetailVehicleRequest',
	mixins: [mixin],
	components: { zForm },
	data: () => ({
		item: {},
	}),

	props: {
		title: 				{ type: String, default: 'Транспортний засіб' },
		icon: 				{ type: String, default: 'mdi-car' },
		maxWidth: 			{ type: Number, default: 480 },
	},

	computed: {
		//...mapGetters('VehicleRequest', [ 'item' ]),

		id() {
			return this.item?.id ? this.item.id : null
		},
	},

	created () {
		//console.log(this.$options.name, 'created')
	},

	methods: {
		...mapActions('VehicleRequest', [ 'setItem' ]),
		
		onOpen () {
			//console.log('details.mixin.main', 'onOpen','selected', this.selected)

			this.item = {};

			if(this.selected) {
				this.item = { ...this.selected };
			}

			/* this.setItem();

			if(this.selected) {
				this.setItem({...this.selected});
			} */
		},

		onClear() {
			this.$refs.parameters.reset()
			//this.clear()
		},

		onOK() {
			//console.log(this.$options.name, 'onOK', 'item', this.item)

			if(this.$refs.parameters.validate()) {
				if(this.selected) {
					//this.selected = {...this.item}
					this.$emit('edit', {...this.item})
				} else {
					this.$emit('add', {...this.item})
				}

				this.dialog = false
			}
		},
	},
}
</script>